'use client';

import CreatorButton from '../Member/components/naviagation/CreatorButton';
import { useRecipeCreatorStore } from '../store/recipeCreatorStore';
import {
  useIsDefaultGNB,
  useIsMajorPathname,
  useIsPathname,
  useIsScrollGNB,
  useShowFixedBTB,
} from '../utils/hook/GNB';
import useMeQuery from '../utils/hook/react-query/user/useMeQuery';
import { usePathnameMethod } from '../utils/hook/usePathnameMethod';

import FixedBTB from './FixedBTB';
import MobileGNBWrapper from './MobileGNBWrapper';
import NavbarCartButton from './NavbarCartButton';
import NavbarLoginButton from './NavbarLoginButton';
import NavbarStartButton from './NavbarStartButton';
import UstoreDetailBTB from './UstoreDetailBTB';

const MobileGNB = () => {
  const { me } = useMeQuery();
  const isDefaultGNB = useIsDefaultGNB();
  const isScrollGNB = useIsScrollGNB();
  const { pathnameStartsWith } = usePathnameMethod();
  const {
    isUstoreDetailPage,
    isUstoreOrderItemDetailPage,
    isRecipeDetailPage,
    isDiaryDetailPage,
  } = useIsMajorPathname();
  const showFixedBTB = useShowFixedBTB();

  const recipeCreatorNameImage =
    useRecipeCreatorStore.use.recipeCreatorNameImage();

  const isReferralReceivePage = useIsPathname('/referral/receive');
  const isCartPage = pathnameStartsWith('/cart');
  const showCartButton = !isCartPage;

  // 상품 디테일(단일상품·품목)의 경우 — GNB 대신 상세 전용 상단 크롬
  if (isUstoreDetailPage || isUstoreOrderItemDetailPage)
    return <UstoreDetailBTB />;

  if (isDefaultGNB) {
    const showRecipeOrDiaryDetailGNB =
      (isRecipeDetailPage || isDiaryDetailPage) && showFixedBTB;

    return (
      <>
        {/* 레시피 or 다이어리 디테일의 경우 & scrollY가 500을 넘길때 */}
        <FixedBTB
          marginTop={8}
          marginBottom={8}
          visibility={showRecipeOrDiaryDetailGNB ? 'visible' : 'invisible'}
        >
          <CreatorButton
            size={32}
            recipeCreatorNameImage={recipeCreatorNameImage ?? undefined}
          />
        </FixedBTB>
        <MobileGNBWrapper
          visibility={showRecipeOrDiaryDetailGNB ? 'invisible' : 'visible'}
          isScrollGNB={isScrollGNB}
          rightButtons={
            isScrollGNB ? (
              <NavbarStartButton />
            ) : (
              <>
                {me ? (
                  showCartButton && <NavbarCartButton />
                ) : (
                  <>
                    {showCartButton && <NavbarCartButton />}
                    <NavbarLoginButton />
                  </>
                )}
              </>
            )
          }
        />
      </>
    );
  }

  return (
    <MobileGNBWrapper
      rightButtons={
        <>
          {me ? (
            !isCartPage && <NavbarCartButton />
          ) : (
            <>
              {!isCartPage && <NavbarCartButton />}
              {!isReferralReceivePage && <NavbarLoginButton />}
            </>
          )}
        </>
      }
    />
  );
};

export default MobileGNB;
